import { BASE_ENDPOINT } from "../../endpoint";

export const retrievePayrollReport = async (TOKEN, companyId, payrollId) => {
  try {
    const url = `${BASE_ENDPOINT}/api/reports/payroll-history/${companyId}/${payrollId}`;
    const response = await fetch(url, {
        method: "GET",
        headers: {
            Authorization: `Bearer ${TOKEN}`,
            "Content-Type": "application/json",
        },
    });
    const res = await response.json();
    if (!response.ok) {
        console.error("Error:", res);
        throw new Error(res.message);
    }
    return res;
  } catch (error) {
    console.error("API fetch error:", error);
    throw error;
  }
};